export let TargetAudience = /*#__PURE__*/function (TargetAudience) {
  TargetAudience["Jobseeker"] = "jobseeker";
  TargetAudience["Enterprise"] = "enterprise";
  TargetAudience["Teacher"] = "teacher";
  TargetAudience["All"] = "all";
  return TargetAudience;
}({});